<template>
	<div>
		<navbar
			@reload="reload"
			:data="item"
			:user="user"
			:type="'edit'"
			:isAuth="isAuth">
		</navbar>

		<div v-if="item" class="row">
			<div class="col-md-12">
				<budgets-datatable
					ref="datatable"
					@reload="reload"
					:user="user"
					:isAuth="isAuth"
					:customer="item">
				</budgets-datatable>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import BudgetsDatatable from '@/components/management/budgets/views/Datatable.vue'
	import Navbar from './Navbar.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'budgets-datatable': BudgetsDatatable,
			'navbar': Navbar,
		},
		data () {
			return {
				item: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
					this.$nextTick( () => this.$refs.datatable.reload())
				}).catch(function(response) {
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Budgets.vue